import * as React from 'react';
import AppView from '../views/app.view';  
import { ICalendarAppBaseText } from '../classes/buytickets-text';

import { IBuyTicketsAppState } from '../redux-state';
import { connect } from 'react-redux'; 

interface AppExternalProps {

}

interface StateToProps {
    text: ICalendarAppBaseText;
    filtersAmount: number;
}
 
export type AppProps = AppExternalProps & StateToProps;
export type AppState = { filtersShouldStick: boolean, filtersAmount:number }

export class AppComponent extends React.Component<AppProps, any> { 
    constructor(props: AppProps) {
        super(props);
    }

    render() {
        return (
            <>
                <AppView {...this.props} />
            </>
        )
    }
}

function mapStateToProps(state: IBuyTicketsAppState, ownProps: AppExternalProps): StateToProps {
    return {
        text: state.calendarText,
        filtersAmount: state.calendar.eventFilter.length 
    }
}

export default connect<StateToProps>(mapStateToProps)(AppComponent);
 